import { usePostHog } from "posthog-js/react";
import { useEffect, useState } from "react";

interface IUseFeatureFlagOptions {
  defaultValue?: boolean;
}

interface IUseFeatureFlagProps {
  featureFlagId?: string;
  featureFlagValue?: string;
  options?: IUseFeatureFlagOptions;
}

export default function useFeatureFlag(props: IUseFeatureFlagProps) {

  const posthog = usePostHog();
  const [ isFeatureFlagActive, setIsFeatureFlagActive ] = useState(props.options?.defaultValue ?? false);

  const updateCanDisplay = () => {
    if (!props.featureFlagId?.length || !props.featureFlagValue?.length) { return true; }
    const flagValue = posthog.getFeatureFlag(props.featureFlagId);
    setIsFeatureFlagActive(flagValue === props.featureFlagValue);
  };

  useEffect(() => {
    posthog?.onFeatureFlags(updateCanDisplay);
  }, [ posthog ]);

  return {
    isFeatureFlagActive,
  };

}
